module.exports = {
	"commitCount": 94,
	"commitMembers": [
		{
			"count": 85,
			"authorName": "airyland"
		},
		{
			"count": 1,
			"authorName": "__FresHmaN"
		},
		{
			"count": 1,
			"authorName": "LinHaobin"
		},
		{
			"count": 1,
			"authorName": "maii"
		},
		{
			"count": 1,
			"authorName": "unclay"
		},
		{
			"count": 1,
			"authorName": "lyh2668"
		},
		{
			"count": 1,
			"authorName": "Qiongrong Jiang"
		},
		{
			"count": 1,
			"authorName": "万刚"
		},
		{
			"count": 1,
			"authorName": "项振兴"
		},
		{
			"count": 1,
			"authorName": "刘杨"
		}
	],
	"commitUniqueCount": 10
};


//////////////////
// WEBPACK FOOTER
// ./en/components/datetime_git_metas.json
// module id = 953
// module chunks = 144